<template>
  <div id="app">
    <h1>Whether</h1>
    <h2>Coming soon...</h2>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
  
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
  * {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    font-family: 'Rubik', 'Segoe UI';
  }
  body {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 100%;
    height: 100vh;
    background-image: linear-gradient(135deg, rgba(14, 51, 216, 0.623), dodgerblue, rgba(52, 2, 218, 0.603));
    color: white;
    font-weight: 300;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue